import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';

const dummyDosageInstructions = [
  { id: '1', ageGroup: 'Adult', dosageAmount: '1-2 tablets every 6 hours' },
  { id: '2', ageGroup: 'Child', dosageAmount: '10mg/kg every 6 hours' },
];

const DosageInstructionsCard = () => {
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-5">Dosage Instructions</CardTitle>
        <div>
          <ul className="verti-timeline list-unstyled">
            {dummyDosageInstructions.map((dosage, i) => (
              <li className={i === 0 ? 'event-list active' : 'event-list'} key={dosage.id}>
                <div className="event-timeline-dot">
                  <i
                    className={
                      i === 0
                        ? 'bx bx-right-arrow-circle bx-fade-right'
                        : 'bx bx-right-arrow-circle'
                    }
                  />
                </div>
                <div className="d-flex">
                  <div className="me-3">
                    <i className="bx bx-capsule h4 text-primary" />
                  </div>
                  <div className="flex-grow-1">
                    <div>
                      <h5 className="font-size-15">{dosage.ageGroup || 'N/A'}</h5>
                      <span className="text-primary">{dosage.dosageAmount || 'N/A'}</span>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </CardBody>
    </Card>
  );
};

export default DosageInstructionsCard;
